import { render, staticRenderFns } from "./StockAdjustmentFormDeduct.vue?vue&type=template&id=65ba9144"
import script from "./StockAdjustmentFormDeduct.vue?vue&type=script&lang=js"
export * from "./StockAdjustmentFormDeduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports